module.exports = __webpack_public_path__ + "img/happy.baf162a9.svg";